import React from 'react';
import {
    AuthEmailStep,
    AuthNameStep,
    AuthCardStep,
    AuthAddressStep,
    AuthAddress2Step,
    AuthPasswordStep,
    AuthLoginStep,
    AuthRecoveryStep,
} from '../steps';
import { useAuthModal } from './useAuthModal';

type AuthModalViewProps = ReturnType<typeof useAuthModal>;

export const AuthModalView: React.FC<AuthModalViewProps> = ({
    step,
    isLoading,
    savedEmail,
    savedName,
    savedCard,
    savedAddress,
    stepError,
    dismissError,
    onEmailSubmit,
    onNameSubmit,
    onCardSubmit,
    onAddressSubmit,
    onAddress2Submit,
    onLoginSubmit,
    onPasswordSubmit,
    onAlreadyHaveAccount,
    onForgotPassword,
    onRecoverySubmit,
    recoverySuccess,
}) => {
    switch (step) {
        case 'email':
            return (
                <AuthEmailStep
                    loading={isLoading}
                    onEmailSubmit={onEmailSubmit}
                    error={stepError}
                    dismissError={dismissError}
                    defaultEmail={savedEmail}
                />
            );
        case 'login':
            return (
                <AuthLoginStep
                    loading={isLoading}
                    email={savedEmail}
                    onLoginSubmit={onLoginSubmit}
                    onForgotPassword={onForgotPassword}
                    recoverySuccess={recoverySuccess}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'recovery':
            return (
                <AuthRecoveryStep
                    email={savedEmail}
                    isLoading={isLoading}
                    error={stepError}
                    onRecoverySubmit={onRecoverySubmit}
                />
            );
        case 'name':
            return (
                <AuthNameStep
                    loading={isLoading}
                    onNameSubmit={onNameSubmit}
                    onAlreadyHaveAccount={onAlreadyHaveAccount}
                    defaultName={savedName}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'card':
            return (
                <AuthCardStep
                    loading={isLoading}
                    onCardSubmit={onCardSubmit}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'card2':
            return (
                <AuthCardStep
                    loading={isLoading}
                    onCardSubmit={onCardSubmit}
                    showNameOnCard
                    defaultCard={savedCard}
                    defaultName={savedName}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'address':
            return (
                <AuthAddressStep
                    loading={isLoading}
                    onAddressSubmit={onAddressSubmit}
                    defaultAddress={savedAddress}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'address2':
            return (
                <AuthAddress2Step
                    key={savedAddress?.countryCode ?? 'US'}
                    loading={isLoading}
                    address={savedAddress}
                    onAddress2Submit={onAddress2Submit}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        case 'password':
            return (
                <AuthPasswordStep
                    loading={isLoading}
                    onPasswordSubmit={onPasswordSubmit}
                    error={stepError}
                    dismissError={dismissError}
                />
            );
        default:
            return null;
    }
};
